export enum BusinessModel {
    PayLater = 0,
    PrePayment = 1,
    NoMenuDisplayed = 2
}
